import styled, { css } from "styled-components";
import {
  BLACK,
  NOTICE_LIGHTEST,
  WHITE
} from "@streeteasy/design-system/colors";
import { Caps } from "@streeteasy/design-system/typography";

import { smallScreen } from "src/shared/constants/screenSizes";

export const Image = styled.img`
  display: block;
  height: 100%;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 0;
  width: 100%;
`;

export const ImageWrapper = styled.div`
  padding-top: 62%;
  position: relative;

  ${({ theme }) =>
    theme === "horizontalCard" &&
    css`
      height: 100%;
      left: 0;
      padding-top: 0;
      position: absolute;
      top: 0;
      width: 40%;
    `}

  @media screen and (max-width: ${smallScreen}px) {
    height: auto;
    padding-top: 0;
    position: relative;
    width: 40%;
  }
`;

export const ImageLabels = styled.div`
  left: 16px;
  position: absolute;
  top: 16px;

  @media screen and (max-width: ${smallScreen}px) {
    display: none;
  }
`;

export const ImageLabel = styled.p`
  margin: 0 0 4px;
`;

export const FeaturedLabel = styled(Caps).attrs({
  as: "span"
})`
  background-color: ${BLACK};
  color: ${WHITE};
  padding: 3px 6px;
`;

export const OpenHouseLabel = styled(Caps).attrs({
  as: "span"
})`
  background-color: ${NOTICE_LIGHTEST};
  color: ${BLACK};
  padding: 3px 6px;
`;

export const CheckIcon = styled.div`
  bottom: 19px;
  left: 22px;
  position: absolute;
  z-index: 20;

  @media screen and (max-width: ${smallScreen}px) {
    display: none;
  }
`;

export const TooltipButton = styled.button`
  background: none;
  border: none;
  padding: 0;
`;
